import { render, staticRenderFns } from "./SecondContent.vue?vue&type=template&id=53ffecc6&scoped=true&"
import script from "./SecondContent.vue?vue&type=script&lang=js&"
export * from "./SecondContent.vue?vue&type=script&lang=js&"
import style0 from "./SecondContent.vue?vue&type=style&index=0&id=53ffecc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ffecc6",
  null
  
)

export default component.exports